import React from 'react';
import { StringColumn, NumericalColumn, CustomColumn } from 'baseui/data-table';
import dayjs from 'dayjs';
import { EMPTY_NUMBER, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	zupeeUserId: 'zupeeuserid',
	ludoTournamentId: 'ludotournamentid',
	playingTableId: 'playingtableid',
	userIpAddress: 'useripaddr',
	gameType: 'game_type',
	entryFee: 'entryfee',
	totalSeats: 'totalseats',
	eventTime: 'eventTime',
	userDeviceId: 'deviceid',
	opponentDeviceId: 'opp_deviceid',
	opponentZupeeUserId: 'opp_zupeeuserid',
	opponentIpAddress: 'opp_ipaddr',
	opponentUsername: 'opp_username',
	opponentPhone: 'opp_phoneno',
	opponentEmailId: 'opp_emailId',
	opponentUpi: 'opp_UPI',
	opponentBankAccountNo: 'opp_bankAccountNo',
	opponentBankAccountHolder: 'opp_bankAccountHolder',
	opponentBankAccountIFSC: 'opp_bankAccountIFSC'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Zupee User Id',
		maxWidth: 200,
		minWidth: 100,
		mapDataToValue: (data: any) => Number(data[COL_NAMES.zupeeUserId]) || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Ludo Tournament Id',
		maxWidth: 200,
		minWidth: 100,
		mapDataToValue: (data: any) => (data[COL_NAMES.ludoTournamentId] ? data[COL_NAMES.ludoTournamentId] : EMPTY_STRING)
	}),
	StringColumn({
		title: 'Playing Table Id',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.playingTableId] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Game Type',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.gameType] || EMPTY_STRING,
		renderCell: (params: any) => {
			const { value } = params;
			let gameTypeCompress = '';
			if (value.length > 10) {
				gameTypeCompress = `${value.substr(0, 10)}...`;
			} else {
				gameTypeCompress = value;
			}
			return <div title={value}>{gameTypeCompress}</div>;
		}
	}),
	NumericalColumn({
		title: 'Entry Fee',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => Number(data[COL_NAMES.entryFee]) || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Total Players',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => Number(data[COL_NAMES.totalSeats]) || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Event Time',
		maxWidth: 300,
		minWidth: 160,
		mapDataToValue: (data: any) =>
			data[COL_NAMES.eventTime] ? dayjs(data[COL_NAMES.eventTime]).format('DD-MM-YYYY HH:mm:ss') : EMPTY_STRING
	}),
	StringColumn({
		title: 'User Device Id',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.userDeviceId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'User Ip Address',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.userIpAddress] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Opp. Zupee Id',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => Number(data[COL_NAMES.opponentZupeeUserId]) || EMPTY_NUMBER,
		format: (value: number): string => (value === EMPTY_NUMBER ? EMPTY_STRING : String(value))
	}),
	StringColumn({
		title: 'Opp. Device Id',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentDeviceId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Ip Address',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentIpAddress] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Username',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentUsername] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Phone',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentPhone] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Email',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentEmailId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. UPI',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentUpi] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Account No',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentBankAccountNo] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Account Holder',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentBankAccountHolder] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Opp. Account IFSC',
		maxWidth: 300,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.opponentBankAccountIFSC] || EMPTY_STRING
	})
];
